import { PropsWithChildren } from 'react'

import { BankAccountRepository } from '@/Contract/domain'
import { IUseBankAccountController, useBankAccountController } from '@/Contract/ui/hooks'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  repository: BankAccountRepository
} & IUseBankAccountController

type Props = PropsWithChildren & {
  repository: BankAccountRepository
  merchantId: number
  origin?: string
}

const [useBankAccount, StateContextProvider] = createGenericContext<Context>()

const AccountProvider = ({
  repository,
  merchantId,
  origin,
  children,
}: Props): JSX.Element => {
  const controller = useBankAccountController(repository, merchantId, origin)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { AccountProvider, useBankAccount }
